import React from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider'
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Onff2 from './blockButton'
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import Deletepop2 from './deletepopUp'




function createData(Hashtag_Name, Videos_Created, Blocked_On, Unblock_Hashtag ) {

  return {Hashtag_Name, Videos_Created, Blocked_On, Unblock_Hashtag   };
}

const rows = [

 
    {
        Hashtag_Name: '#Quickbites',
        Videos_Created: '12325',
        Blocked_On: '21-05-2021',
        Unblock_Hashtag: '<Onff/>'
      },

];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: '100%',
  },
  Card:{
    maxHeight: 20,
  },
  Avatar: {
    maxHeight: 25,
    maxWidth: 25,
  },

  link: {
      '& > * + *': {
        marginLeft: theme.spacing(51),
      },
    },
  Table: {
      
    '&:nth-of-type(odd)': {
      backgroundColor: "white",
    },
    '&:nth-of-type(even)': {
      backgroundColor: "red",
    },

  },
  Deleteicon: {
    color:"grey",
    "&:hover, &.Mui-focusVisible": { color: "#FF0027" }
  },
 
  
   
  }));

export default function StickyHeadTable() {
  const preventDefault = (event) => event.preventDefault();
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    
    
    <Paper elevation={0} className={classes.root}>
      <Card className={classes.Card} >
      <Typography className={classes.link} variant="h8" color="#001441">
     
    </Typography>

      </Card>
      
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" className={classes.Table}>
          <TableHead>
            <TableRow>
            <TableCell align="left" id="Table-cell">Hashtag Name</TableCell>
            <TableCell align="left" id="Table-cell">Videos Created</TableCell>
            <TableCell align="left" id="Table-cell">Blocked On</TableCell>
            <TableCell align="center" id="Table-cell">Unblock Hashtag</TableCell>
                </TableRow>
              
            
          </TableHead>
          <TableBody className="table-body">
            {rows.map((row) => (
                <TableRow  className="table-row">
                       <TableCell align="left" className="Table-cell">{row.Hashtag_Name}</TableCell>
                      <TableCell align="left" className="Table-cell">{row.Videos_Created}</TableCell>
              <TableCell align="left" className="Table-cell">{row.Blocked_On}</TableCell>
              <TableCell align="center" ><Onff2 src={row.Unblock_Hashtag}/></TableCell>
                </TableRow>
              
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
